import type { McpToken } from "../lib/mcpTokens";

/** ══ MCP 토큰 견본 — 패턴 페이지(`#/patterns`) 전용 ══
 *  무제한 · 날짜 만료 · 만료됨 · 범위 전체/고름/빈 범위 · 안 써 봄을 한 표에 섞었다. */
export const PAT_MCP_NOW = Date.parse("2026-10-31T06:00:00Z");

export const PAT_MCP_PROJECTS = [
  { id: "b3x-in", name: "b3x-in" },
  { id: "mops-code", name: "mops-code" },
  { id: "penna", name: "mops-penna" },
];

export const PAT_MCP_TOKENS: McpToken[] = [
  {
    name: "claude-code-laptop",
    createdBy: "admin",
    createdAt: "2026-10-20T01:00:00Z",
    lastUsedAt: "2026-10-31T05:52:00Z",
    expiresAt: null,
    expired: false,
    projects: null,
  },
  {
    name: "codex-ci",
    createdBy: "admin",
    createdAt: "2026-10-25T03:00:00Z",
    lastUsedAt: "2026-10-30T12:00:00Z",
    expiresAt: "2026-11-24T03:00:00Z",
    expired: false,
    projects: ["b3x-in", "mops-code"],
  },
  {
    name: "old-harness",
    createdBy: "o2hp",
    createdAt: "2026-09-01T00:00:00Z",
    lastUsedAt: "2026-09-20T00:00:00Z",
    expiresAt: "2026-10-01T00:00:00Z",
    expired: true,
    projects: ["penna"],
  },
  {
    name: "parked",
    createdBy: "admin",
    createdAt: "2026-10-30T00:00:00Z",
    lastUsedAt: null,
    expiresAt: "2026-11-06T00:00:00Z",
    expired: false,
    projects: [],
  },
];
